var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0022 1C19.6309 1 25.0045 6.37358 25.0045 13.0022C25.0045 19.6309 19.6309 25.0045 13.0022 25.0045C6.37359 25.0045 1 19.6309 1 13.0022C1 6.37359 6.37358 1 13.0022 1Z",
    stroke: "#49A71B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2571 9.31863L11.3024 15.3285L8.83 12.5461C8.42613 12.0954 7.75572 12.0788 7.33262 12.509C6.90951 12.9393 6.89391 13.6535 7.2978 14.1042L10.5015 17.6656C10.6921 17.8788 10.9564 17.9995 11.2328 17.9995C11.5047 18.0137 11.7699 17.9061 11.964 17.7027L18.6848 10.9138C19.0928 10.4913 19.1083 9.79854 18.7197 9.35575C18.5339 9.13762 18.2723 9.0102 17.9958 9.00319C17.7194 8.99617 17.4524 9.11019 17.2571 9.31864L17.2571 9.31863Z",
    fill: "#49A71B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick2);
export default __webpack_public_path__ + "static/media/green-tick-2.6cc59b4c4bb646c89a06d7dfc05f0212.svg";
export { ForwardRef as ReactComponent };